import { render, staticRenderFns } from "./ItemFileIndex.vue?vue&type=template&id=2ce60acf&scoped=true&"
import script from "./ItemFileIndex.vue?vue&type=script&lang=js&"
export * from "./ItemFileIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce60acf",
  null
  
)

export default component.exports